import { Box, Container, Divider, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import AvaibilityIconComponent from "../PartsList/TableLayout/TableColumnComponents/AvaibilityIconComponent";
import NoteIconComponent from "../PartsList/TableLayout/TableColumnComponents/NoteIconComponent";
import { WarrantyItemForDamaged, WarrantyItemForMissing } from "../../types";
import {
    DialogContainer,
    PaperContainer,
} from "./MissingPartsWrongMaterial/MissingPartsWrongMaterial.style";
import { usePartFormatter } from "../../hook/usePartFormatter";
import PriceFormatComponentWithZero from "../PartsList/TableLayout/TableColumnComponents/PriceFormatComponentWithZero";
import { NoteSimpleIconComponent } from "../PartsList/TableLayout/TableColumnComponents/NoteSimpleIconComponent";

type TWarrantyBasketItems = {
    item: WarrantyItemForDamaged | WarrantyItemForMissing;
   
    children: JSX.Element;
    readOnly:boolean
};

const WarrantyBasketItems: FC<TWarrantyBasketItems> = (props) => {
    const { item, children,readOnly } = props;
    const partFormatter = usePartFormatter();

    const [machine, setMachine] = useState("");
    const [table, setTable] = useState("");
    const [position, setPosition] = useState("");

    useEffect(() => {
        if (item) {
            partFormatter.getDataByNavContext(
                item.navContext ?? "",
                (m, t, p) => {
                    setMachine(m);
                    setTable(t);
                    setPosition(p);
                }
            );
        }
    }, [item]);

    
    return (
        <PaperContainer
            key={`${item.rowId}_${item.code}_${item.partDescription}_${item.navContext}`}
            elevation={4}
            sx={{ borderRadius: "5px" }}
        >
            <Container
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "5px 0px",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexGrow: 1,
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Box sx={{ width: 300 }}>
                        <Typography variant="body1">{`${item.code} / ${item.partDescription}`}</Typography>
                        <Typography variant="body2">{`${partFormatter.getNavContextByData(
                            machine,
                            table,
                            position
                        )}`}</Typography>
                    </Box>
                    <Box sx={{ width: 150, textAlign: "right" }}>
                        <NoteSimpleIconComponent
                            item={item}
                            additionalProps={{
                                typeSubmit: "ORDER_FROM_WARRANTY",
                                readOnly: readOnly,
                               

                            }}
                        ></NoteSimpleIconComponent>
                        
                    </Box>
                    <Box sx={{ width: 150 }}>
                        <AvaibilityIconComponent
                            item={item}
                            additionalProps={{ loadingPrices: false }}
                        />
                    </Box>
                    <Box sx={{ width: 150, textAlign: "center" }}>
                        <Typography>{`${item.qty} PCE`}</Typography>
                    </Box>
                    <Box sx={{ width: 150, textAlign: "right" }}>
                        <PriceFormatComponentWithZero
                            item={item}
                            colName="grossUnitPrice"
                        />
                    </Box>
                    <Box sx={{ width: 150, textAlign: "right" }}>
                        <PriceFormatComponentWithZero
                            item={item}
                            colName="netTotalPrice"
                        />
                    </Box>
                </Box>
                <Divider />
                {children}
            </Container>
        </PaperContainer>
    );
};
export default WarrantyBasketItems;
